import '../index.css';

import { useState } from 'react';

import doubleArrowImgSrc from '../../../../assets/icons/side-menu-left-right-arrow.png';
import { ReactComponent as CollapseExpandSvg } from '../../../../assets/icons/collapse-expand.svg';

import { ReactComponent as LogoIcon } from '../../../../assets/logo/abcc-side.svg';
import { useTranslation } from '../../../../hooks';

interface ToggleButtonProps {
  isCollapse: boolean;
  onCollapseClick?: () => void;
}

const ToggleButton = (props: ToggleButtonProps) => {
  const { onCollapseClick, isCollapse } = props;

  // boolean for animation usage
  const [isClicked, setIsClicked] = useState(false);

  const { t } = useTranslation('menu');

  const arrowImgSrc = doubleArrowImgSrc;
  // const text = isCollapse ? `${t('toggleBtnExpand')}` : `${t('toggleBtnCollapse')}`;

  const onClick = () => {
    setIsClicked(true);
    onCollapseClick && onCollapseClick();
  };

  const onAnimationEnd = () => {
    setIsClicked(false);
  };

  return (
    <>
      {isCollapse && <div className={`toggle-btn-overlay`}></div>}
      <div
        onClick={onClick}
        onAnimationEnd={onAnimationEnd}
        className={`toggle-btn
          ${isCollapse ? 'expand' : 'collapse'}
          ${isClicked ? 'fade-in-out' : ''}
        `}
      >
        {/* {isCollapse && <LogoIcon
          className={`toggle-btn-icon`}
        />} */}
        <div style={{ marginTop: '24px' }}>
          <CollapseExpandSvg className={`arrow ${isCollapse && 'expand'}`} />
        </div>
      </div>
    </>
  );
};

export default ToggleButton;
